module.exports = __webpack_public_path__ + "img/bag.3b4c75e3.svg";